module.exports = __webpack_public_path__ + "img/bosspack_cod_dg_k.b00f7953.png";